export default __webpack_public_path__ + "static/automate-do-1-8cf2f272b24f8769c23f3b1a1f5fcbe1.png";